import * as React from "react";
import type { SVGProps } from "react";
const SvgContent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M39.088 48.573H25.274v-1.75h13.814v1.75ZM45.835 25.614a4.125 4.125 0 0 0-5.967.106l-14.23 15.445-1.286-1.186L38.58 24.534a5.875 5.875 0 0 1 8.498-.15l9.946 10.059-1.244 1.23-9.946-10.059Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M10.566 5.634a4.125 4.125 0 0 0-4.125 4.125v24.727h-1.75V9.759a5.875 5.875 0 0 1 5.875-5.875h43.23a5.875 5.875 0 0 1 5.875 5.875v24.727h-1.75V9.759a4.125 4.125 0 0 0-4.125-4.125h-43.23Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M23.986 26.619a4.125 4.125 0 0 0-5.873-.042l-9.156 9.15L7.72 34.49l9.155-9.15a5.875 5.875 0 0 1 8.365.059l7.569 7.782-1.255 1.22-7.568-7.782Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M21 35.866H5a3.25 3.25 0 0 0-3.25 3.25v16A3.25 3.25 0 0 0 5 58.366h16a3.25 3.25 0 0 0 3.25-3.25v-16a3.25 3.25 0 0 0-3.25-3.25Zm-16-1.75a5 5 0 0 0-5 5v16a5 5 0 0 0 5 5h16a5 5 0 0 0 5-5v-16a5 5 0 0 0-5-5H5ZM59 35.866H43a3.25 3.25 0 0 0-3.25 3.25v16a3.25 3.25 0 0 0 3.25 3.25h16a3.25 3.25 0 0 0 3.25-3.25v-16a3.25 3.25 0 0 0-3.25-3.25Zm-16-1.75a5 5 0 0 0-5 5v16a5 5 0 0 0 5 5h16a5 5 0 0 0 5-5v-16a5 5 0 0 0-5-5H43Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M6 42.688c0-.69.475-1.25 1.06-1.25h11.88c.585 0 1.06.56 1.06 1.25s-.475 1.25-1.06 1.25H7.06c-.585 0-1.06-.56-1.06-1.25ZM6 51.188c0-.69.475-1.25 1.06-1.25h11.88c.585 0 1.06.56 1.06 1.25s-.475 1.25-1.06 1.25H7.06c-.585 0-1.06-.56-1.06-1.25Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M45.522 43.1v7.988c0 1.5 1.589 2.466 2.92 1.776l7.82-4.054c1.448-.752 1.436-2.829-.022-3.562l-7.82-3.935a2 2 0 0 0-2.898 1.786Z"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M48.027 42.094a1.125 1.125 0 0 0-1.63 1.005v7.99c0 .843.894 1.386 1.642.998l7.82-4.054a1.125 1.125 0 0 0-.013-2.004l-7.819-3.935Zm-3.38 1.005c0-2.14 2.255-3.53 4.167-2.568l7.819 3.935c2.096 1.055 2.114 4.04.03 5.12l-7.818 4.055c-1.914.992-4.198-.397-4.198-2.552v-7.99Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgContent;
